// @flow
import React, { Component } from "react";

import { Link } from "react-router-dom";

import { Login } from "../components/login/index";

import { ServiceManager } from "../service/service-manager";

import { Validation } from "../model/validation";

type Props = {
    serviceManager: ServiceManager
};

type States = {
    email: string,
    emailValidation: Validation,
    password: string,
    passwordValidation: Validation,
    serverValidateFail: boolean,
    serverValidateMsg: ?string,
    loggingIn: boolean,
    loginStatus: "" | "loading" | "success",
    loginButtonText: string
};

export class LoginContainer extends Component<Props, States> {
    state: States;
    constructor(props: Props) {
        super(props);
        this.state = {
            email: "",
            emailValidation: this.getDefaultValidationEmailSuccess(),
            password: "",
            passwordValidation: this.getDefaultValidationPasswordSuccess(),
            loggingIn: false,
            loginStatus: "",
            loginButtonText: "Login",
            serverValidateFail: false,
            serverValidateMsg: null
        };
    }
    login = async (e: Event) => {
        e.preventDefault();
        const emailValid = this.validateEmail(this.state.email);
        const passwordValid = this.validatePassword(this.state.password);
        this.setState({
            emailValidation: emailValid,
            passwordValidation: passwordValid
        });
        const valid =
            emailValid.success === "success" &&
            passwordValid.success === "success";
        if (valid === true) {
            const promiseLogin = this.props.serviceManager.loginService.login(
                this.state.email,
                this.state.password
            );
            this.setState({
                loggingIn: true,
                loginStatus: "loading",
                loginButtonText: "Loading"
            });
            try {
                const { redirectUrl } = await promiseLogin;
                this.setState({ loginStatus: "success" });
                window.sessionStorage.removeItem(
                    "reece-user-template-context-data"
                );
                window.location.assign(redirectUrl);
            } catch (e) {
                this.setState({
                    loginStatus: "",
                    serverValidateFail: true,
                    serverValidateMsg: e.errorMessage
                });
            } finally {
                this.setState({ loggingIn: false, loginButtonText: "Login" });
            }
        }
    };
    onEmailChanged = (e: Event, email: string) => {
        const emailValidation = this.validateEmail(email);
        this.setState({ email, emailValidation });
    };
    validateEmail = (email: string) => {
        return this.props.serviceManager.validationService.validateEmail(email);
    };
    onPasswordChanged = (e: Event, password: string) => {
        const passwordValidation = this.validatePassword(password);
        this.setState({ password, passwordValidation });
    };
    validatePassword = (password: string) => {
        return this.props.serviceManager.validationService.validatePasswordForLogin(
            password
        );
    };
    isFormInvalid = () => {
        return (
            this.state.emailValidation.success !== "success" ||
            this.state.passwordValidation.success !== "success"
        );
    };
    getDefaultValidationEmailSuccess = () => ({
        success: "",
        required: false,
        format: false
    });
    getDefaultValidationPasswordSuccess = () => ({
        success: "",
        required: false
    });
    render() {
        return this.state.loginStatus !== "success" ? (
            <div className="login-page__section-login">
                <h1 className="login-page__section-login-header">Login</h1>
                <hr />
                <div className="form-intro">
                    Welcome back! Sign in to your online account below.
                </div>
                <div className="form-wrapper login-page__section-login-form">
                    <Login
                        email={this.state.email}
                        emailValidation={this.state.emailValidation}
                        password={this.state.password}
                        passwordValidation={this.state.passwordValidation}
                        serverValidateFail={this.state.serverValidateFail}
                        serverValidateMsg={this.state.serverValidateMsg}
                        status={
                            this.state.loginStatus === "loading"
                                ? "loading"
                                : ""
                        }
                        disabledLogin={this.state.loggingIn}
                        loginButtonText={this.state.loginButtonText}
                        onEmailChanged={this.onEmailChanged}
                        onPasswordChanged={this.onPasswordChanged}
                        onSubmit={this.login}
                    />
                    <Link id="forgotpassword" to={"/password/recover"}>
                        Forgot your password?
                    </Link>
                </div>
            </div>
        ) : (
            <div className="login-page__section-login">
                <div className="form-wrapper login-page__section-login-form">
                    <div className="login-success-message">
                        Login success, redirecting...
                    </div>
                </div>
            </div>
        );
    }
}
